import { Skeleton } from '@mui/material'
import dynamic from 'next/dynamic'
import Router from 'next/router'
import { useFetch } from 'use-http'
import { API_URL } from '../../constants/api'
import { NFT } from '../../types'
const Button = dynamic(() => import('../common/Buttons'))
const NFTCards = dynamic(() => import('../common/NFTCards'))

const Trending = () => {
  const { data } = useFetch(
    `${API_URL}/marketplace/trending`,
    { method: 'POST' },
    []
  )

  if (!data) {
    return (
      <>
        <div className="my-4 flex w-full flex-row items-center justify-between">
          <Skeleton
            animation="wave"
            variant="rectangular"
            className="h-8 w-36 bg-gray-400/20 md:w-72"
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            className="h-8 w-20 bg-gray-400/20 md:w-48"
          />
        </div>

        <div className="grid w-full grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {[1, 2, 3, 4, 5, 6].map((index) => (
            <Skeleton
              animation="wave"
              key={index}
              variant="rectangular"
              className="mt-1 mr-1 h-56 w-full bg-gray-400/20 md:h-72"
            />
          ))}
        </div>
      </>
    )
  }

  return (
    <div className="mt-5 flex w-full flex-col items-start">
      <div className="mb-4 flex w-full flex-row items-center justify-between">
        <div className="flex flex-col items-start justify-center md:flex-row md:items-center">
          <p className="font-MonumentRegular text-lg uppercase text-white md:text-xl">
            Trending Assets
          </p>
          <p className=" ml-2 font-oswaldregular text-sm text-gray-300 opacity-60">
            In Last 24 Hours
          </p>
        </div>
        <Button
          type="shaded"
          text="See all"
          px={4}
          py={3}
          sm
          onClick={() => {
            Router.push(`/trending`)
          }}
        />
      </div>
      <div className="grid w-full grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-5">
        {data?.data?.trendingAsset?.map((asset: NFT, index: number) => {
          if (index >= 10) return
          return (
            <NFTCards
              key={asset.id}
              onClick={() => Router.push(`/trending/${asset.id}`)}
              id={asset.id}
              file={asset?.file}
              name={asset.name}
              thumbnail={asset.thumbnail}
              type={asset.type}
              price={asset.price}
              creator_id={asset.creator_id}
              creator_name={asset.creator_name}
              description={asset.description}
              is_nft={asset.is_nft}
            />
          )
        })}
      </div>
    </div>
  )
}

export default Trending
